// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Container imports
const TooltipBubble = require('../components/bubble')

class TooltipItemRecord extends Immutable.Record({
  key: String(),
  uniqueId: null,
  title: String(),
  body: String(),
  isDismissed: Boolean(),
  onDismiss: null, // Optional Function
  renderCustom: null // Optional Function (React Render Prop)
}) {
  render() {
    if (this.renderCustom) {
      return this.renderCustom()
    }
    return this.renderDefault()
  }

  renderDefault() {
    return tag([
      TooltipBubble.renderTitle(this.title),
      TooltipBubble.renderBody(this.body)
    ])
  }
}

TooltipItemRecord.reviver = function () {
  throw new Error('TooltipItemRecord does not support revival')
}

module.exports = TooltipItemRecord
